module.exports = __webpack_public_path__ + "img/InformaciondeInteres.91e57e74.png";